// "undefined"===typeof Shopify&&(window.Shopify={});"undefined"===typeof Shopify.getCart&&(Shopify.getCart=function(a,b){if(!b)return jQuery.getJSON("/cart.js",function(c,d,e){if("function"===typeof a)a(c,d,e);else Shopify.onCartUpdate(c)});if("function"===typeof a)a(b);else if("function"===typeof Shopify.onCartUpdate)Shopify.onCartUpdate(b)});
// customElements.get("product-form")||customElements.define("product-form",class extends HTMLElement{constructor(){super();this.form=this.querySelector("form");this.form.addEventListener("submit",this.onSubmitHandler.bind(this));this.cartNotification=document.querySelector("cart-notification")}onSubmitHandler(a){a.preventDefault();this.cartNotification.setActiveElement(document.activeElement);const b=this.querySelector('[type="submit"]');b.setAttribute("disabled",!0);b.classList.add("loading");a=JSON.stringify({...JSON.parse(serializeForm(this.form))});
// fetch(`${routes.cart_add_url}`,{...fetchConfig("javascript"),body:a}).then(c=>c.json()).then(c=>{Shopify.getCart(function(d){Shopify.AjaxCart.api.updateCart()})}).catch(c=>{console.error(c)}).finally(()=>{b.classList.remove("loading");b.removeAttribute("disabled");Shopify.AjaxCart.functions.cartOpen()})}});

"undefined" === typeof Shopify && (window.Shopify = {});
"undefined" === typeof Shopify.getCart &&
    (Shopify.getCart = function (a, b) {
        if (!b)
            return jQuery.getJSON("/cart.js", function (c, d, e) {
                if ("function" === typeof a) a(c, d, e);
                else Shopify.onCartUpdate(c);
            });
        if ("function" === typeof a) a(b);
        else if ("function" === typeof Shopify.onCartUpdate) Shopify.onCartUpdate(b);
    });
customElements.get("product-form") ||
    customElements.define(
        "product-form",
        class extends HTMLElement {
            constructor() {
                super();
                this.form = this.querySelector("form");
                this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
                this.cartNotification = document.querySelector("cart-notification");
            }
            onSubmitHandler(a) {
                a.preventDefault();
                this.cartNotification.setActiveElement(document.activeElement);
                const b = this.querySelector('[type="submit"]');
                b.setAttribute("disabled", !0);
                b.classList.add("loading");
                window.frenzyCartProperties = { _event_name: "pdp_add_to_cart", _user_id: user_id_Frenzy ? user_id_Frenzy.toString() : null };
                const formData = {...JSON.parse(serializeForm(this.form)),properties: {...window.frenzyCartProperties}};
                a = JSON.stringify(formData);
                fetch(`${routes.cart_add_url}`, { ...fetchConfig("javascript"), body: a })
                    .then((c) => c.json())
                    .then((c) => {
                        Shopify.getCart(function (d) {
                            Shopify.AjaxCart.api.updateCart();
                        });
                        frenzyAsyncItems();
                    })
                    .catch((c) => {
                        console.error(c);
                    })
                    .finally(() => {
                        b.classList.remove("loading");
                        b.removeAttribute("disabled");
                        Shopify.AjaxCart.functions.cartOpen();
                    });
            }
        }
    );